export default "<p>date-picker works!</p>\r\n"